import React from 'react'
import Card from '@material-ui/core/Card';
import StyledOutlinedButton from './inputs/StyledOutlinedButton'
import CustomDialog from './inputs/CustomDialog'
import TextInput from './inputs/TextInput'

class ProfileDelete extends React.Component {
  state = {
    showDialog: false,
    confirmField: '',
    confirmError: false
  }

  showDialog = function(){
    this.setState({showDialog: true})
  }
  hideDialog = function(){
    this.setState({showDialog: false})
  }
  handleAccept = function(value) {
    const val = value.toUpperCase()
    if (val === "YES") {
      this.hideDialog()
      this.props.deleteUser()
    }
  }
  handleChange = function(event) {
    const val = event.target.value.toUpperCase()
    this.setState({confirmField: val})
    if (val === "YES") {
      this.setState({confirmError: false})
    } else {
      this.setState({confirmError: true})
    }
  }

  render() {

    return (
      <React.Fragment>
        <div className="card-header">
          <div className="mt-36 mb-8" style={{fontSize: '75%', padding: 8}}>
          You can delete your account with InstaLevel at any time. All your personal data will be removed from our servers.
          </div>
        </div>
        <div className="card-divider" />
        <div className="card-body text-center">

          <StyledOutlinedButton
            size="small"
            aria-label="Delete account"
            className="mdc-instalevel-w-100 ls-125 no-bg fs-10"
            onClick={ this.showDialog.bind(this)}
          >PERMANENTLY DELETE ACCOUNT</StyledOutlinedButton>

        </div>
        <CustomDialog
          id={`active-dialog`}
          qid={this.state.confirmField}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.handleAccept.bind(this)}
          fullScreen = {false}
          title={`Really delete your account?`}
        >
          This action cannot be undone! If you know what you are doing, type 'YES' and press OK.
          <TextInput
            id="register-name"
            nocontrol={true}
            className="mdc-instalevel-w-100"
            error={this.state.confirmError}
            label="Confirm account deletion"
            placeholder="Type YES to delete your account"
            helperText="Type YES to delete your account"
            onChange={this.handleChange.bind(this)}
          />

        </CustomDialog>

      </React.Fragment>
    )
  }
}

export default ProfileDelete



// WEBPACK FOOTER //
// ./src/js/components/ProfileDelete.js